export default {"src":"/_next/static/media/handle.66798d95.svg","height":19,"width":27,"blurWidth":0,"blurHeight":0};